import { useEffect, useRef, useState } from 'react'

import { TTabNames } from './components/types'

import Tab from './components/Tab'
import Search from './components/Search'
import Upload from './components/Upload'
import Url from './components/Url'
import FileChooser from './components/FileChooser'
import UploadError from './components/Error'
import Title from './components/ContentTitle'
import ContentWrapper from './components/ContentWrapper'
import Description from './components/ContentDescription'
// import Ad from './Advertisement'
import { checkMobile } from '@templateroller/helpers/dist/helpers'
import { sendUploadInitEvent } from '@templateroller/helpers/dist/api/dot-events'

import { ProgressBar, FullProgressBar } from './components/ProgressBar'
import ProgressList from './components/ProgressList'
import Tabs from './components/TabList'
import Loader from './components/ProgressLoader'
import Submit from './components/Submit'
import { getRedirectToDrawURL } from './components/helpers'

export type TStatus = string

type TUploadStatus = {
    type: 'device'|'url',
    status: TStatus,
    message: string,
    progress: number,
}

const Uploader = () => {
    const [activeTab, switchTab] = useState<TTabNames>('upload')

    const defaultUploadStatus: TUploadStatus = {
        type: 'device',
        status: 'ready',
        message: '',
        progress: 100,
    }

    const [uploadStatus, setUploadState] = useState<TUploadStatus>(defaultUploadStatus)

    // реф на div.form-wrapper
    const formWrapperRef = useRef(document.querySelector<HTMLDivElement>('.form-wrapper'))

    const handleTabClick = (tab: TTabNames) => {
        // добавяем класс suggest с индексом, предотвращая наложения на суггесты
        if (formWrapperRef?.current) {
            const formWrapperClass = formWrapperRef.current.classList
            if (tab === 'search') {
                formWrapperClass.add('suggest')
            } else {
                if (formWrapperClass.contains('suggest')) {
                    formWrapperClass.remove('suggest')
                }
            }
        }
        
        switchTab(tab)
        setUploadState(defaultUploadStatus)
    }
    
    const data = {
        'search': {
            title: 'Browse Fillable Documents',
            description: 'Browse our library of over 100 thousand forms by name or description and begin editing, signing, and sharing the documents you need!',
            content: <Search />,
        },
        'upload': {
            title: '',
            description: '',
            content: null,
        },
        'url': {
            title: 'Add Documents from the Web',
            description: 'Enter the URL of a document hosted online to add it and begin editing, signing, and sharing',
            content: <Url
                setUploadStatus={(status, message) => setUploadState({status, message, progress: 100, type: 'url'})}
            />,
        }
    }

    const content = data[activeTab]

    // проверяем и дописываем в куку версию UA
    useEffect(() => {
        checkMobile()
        // init стата
        sendUploadInitEvent()
    },[])

    return <FileChooser>
        <Tabs className='long' activable={['ready', 'error', 'redirecting'].includes(uploadStatus.status)}>
            <Tab
                isActive={activeTab === 'search'}
                onClick={() => handleTabClick('search')}
            >
                Search for Documents
            </Tab>
            <Tab
                isActive={activeTab === 'upload'}
                onClick={() => handleTabClick('upload')}
            >
                Upload Document
            </Tab>
            {/* <Tab
                isActive={activeTab === 'url'}
                onClick={() => handleTabClick('url')}
            >
                Enter URL of Document
            </Tab> */}
        </Tabs>

        <Tabs className='short' activable={['ready', 'error', 'redirecting'].includes(uploadStatus.status)}>
            <Tab
                isActive={activeTab === 'search'}
                onClick={() => handleTabClick('search')}
            >
                Search
            </Tab>
            <Tab
                isActive={activeTab === 'upload'}
                onClick={() => handleTabClick('upload')}
            >
                Upload
            </Tab>
            {/* <Tab
                isActive={activeTab === 'url'}
                onClick={() => handleTabClick('url')}
            >
                Enter URL
            </Tab> */}
        </Tabs>

        {
            activeTab === 'upload' &&
            uploadStatus.status === 'ready' &&
            <>
                {/* <Ad adNum={0} /> */}
                <Upload
                    setUploadStatus={(status, message, progress) => setUploadState({status, message, progress, type: 'device'})}
                    uploadStatus={uploadStatus.status}
                />
                {/* <Ad adNum={1} margin="0 0 6px" /> */}
            </>
        }

        {
            activeTab === 'upload' && uploadStatus.type === 'device' && ['waiting', 'uploading', 'converting', 'redirecting'].includes(uploadStatus.status) &&
            <>
                {/* <Ad adNum={0} /> */}
                <ContentWrapper>
                    <Title>Processing, please wait a moment...</Title>

                    <FullProgressBar>
                        <ProgressBar width={uploadStatus.progress} />
                    </FullProgressBar>

                    <ProgressList status={uploadStatus.status} />
                    {
                        uploadStatus.status === 'redirecting' &&
                        <Submit as="a" href={getRedirectToDrawURL(Number(uploadStatus.message))}>Click to edit your document</Submit>
                    }
                </ContentWrapper>
                {/* <Ad adNum={1} margin="0 0 6px" /> */}
            </>
        }

        {
            activeTab === 'url' && uploadStatus.type === 'url' && ['waiting', 'uploading', 'converting', 'redirecting'].includes(uploadStatus.status) && 
            <>
                {/* <Ad adNum={0} /> */}
                <ContentWrapper>
                    <Title>{data['url'].title}</Title>
                    <Description>{data['url'].description}</Description>
                    <Loader />
                    <ProgressList status={uploadStatus.status} />
                    {
                        uploadStatus.status === 'redirecting' &&
                        <Submit as="a" href={getRedirectToDrawURL(Number(uploadStatus.message))}>Click to edit your document</Submit>
                    }
                </ContentWrapper>
                {/* <Ad adNum={1} margin="0 0 6px" /> */}
            </>
        }

        {
            uploadStatus.status === 'error' &&
            <>
                {/* <Ad adNum={0} /> */}
                <UploadError message={uploadStatus.message} tryAgain={() => setUploadState(defaultUploadStatus)} />
                {/* <Ad adNum={1} margin="0 0 6px" /> */}
            </>
        }

        {
            activeTab !== 'upload' &&
            uploadStatus.status === 'ready' &&
            <>
                {/* <Ad adNum={0} /> */}
                <ContentWrapper>
                    <Title>{content.title}</Title>
                    <Description>{content.description}</Description>
                    {content.content}
                </ContentWrapper>
                {/* <Ad adNum={1} margin="0 0 6px" /> */}
            </>
        }
    </FileChooser>
}

export default Uploader